import React from 'react';
import { connect } from 'react-redux';
import { Content, Toast, Flex, Text, Button, Dialog } from '@leverege/ui-elements';
import classnames from 'classnames';
import Prom from '@leverege/promise';
import I18N from '@leverege/i18n';
import { camelCaseToTitleCase } from '@leverege/string-util';
import FileForm from "./FileForm.js";
import BulkResultsTable from "./BulkResultsTable.js";
import { csvToJSON, Validators } from "../../utils/index.js";
import pairIcon from '../../../images/pairIcon.png';
import S from './Pair.css';
const {
  t
} = I18N.ns('pairing.bulkPairing.views.BulkPairFlow');
class BulkPairFlow extends React.Component {
  static defaultProps = {
    objectIdValidator: Validators.notNullOrEmpty,
    parentIdValidator: Validators.notNullOrEmpty
  };
  constructor(props) {
    super(props);
    this.state = {
      tabId: ''
    };
  }
  onFinish = evt => {
    const {
      onClose
    } = this.props;
    onClose();
  };
  onPair = async evt => {
    const {
      onPair,
      actions,
      objectType,
      parentColumnName,
      parentObjectName,
      objectColumnName,
      dispatch,
      parentNetwork,
      parentObjectType,
      parentNetworkIdentifier
    } = this.props;
    const {
      csv
    } = this.state;
    this.setState({
      loading: true
    });
    let data;
    try {
      data = csvToJSON(csv);
    } catch (ex) {
      Toast.error([t('badCSV')], {
        containerId: 'api-ui-pairing'
      });
      this.setState({
        loading: false
      });
      return;
    }
    const parentDevices = await dispatch(actions.search({
      filter: {
        type: 'equals',
        field: `networkAliases.${parentNetwork}.${parentNetworkIdentifier}`,
        value: this.validateParentIds(data),
        fieldType: 'string'
      }
    }));
    const promiseResults = await Prom.map(data, async (pairData, index) => {
      const objectId = pairData[objectColumnName];
      const parentId = pairData[parentColumnName];
      let object;
      const parent = parentDevices.items.find(a => a?.networkAliases[parentNetwork] && a?.networkAliases[parentNetwork][parentNetworkIdentifier] === parentId);
      if (!parent) {
        return {
          ...pairData,
          index,
          message: t('noParent', {
            parentObjectName
          })
        };
      }
      try {
        if (!objectId) {
          return {
            ...pairData,
            index,
            message: t('noObjectId', {
              objectColumnName
            })
          };
        }
        object = await this.validateObject(objectId);
      } catch (ex) {
        return {
          ...ex,
          ...pairData,
          index
        };
      }
      try {
        let result;
        if (typeof onPair === 'function') {
          result = await onPair({
            parent,
            object
          });
        } else {
          result = await dispatch(actions.itemActions(parent.id).createObj().obj(objectType).create({
            id: object.id
          }));
        }
        return {
          object: result,
          success: true,
          ...pairData,
          index,
          data: parent,
          type: parentObjectType
        };
      } catch (ex) {
        return {
          ...ex,
          ...pairData,
          object,
          index,
          data: parent,
          type: parentObjectType
        };
      }
    });
    if (promiseResults.filter(d => d.success).length === 0) {
      Toast.error([t('toastError')], {
        containerId: 'api-ui-pairing'
      });
    } else if (promiseResults.filter(d => !d.success).length === 0) {
      Toast.success(t('allToastSuccess'), {
        containerId: 'api-ui-pairing'
      });
    } else {
      Toast.success(t('partialToastSuccess', {
        count: promiseResults.filter(d => !d.success).length
      }));
    }
    this.setState({
      loading: false,
      results: promiseResults,
      tabId: 'uploadResults'
    });
  };
  updateState = async evt => {
    this.setState({
      [evt.data]: evt.value
    });
  };
  overridePairing = async event => {
    const {
      actions,
      dispatch,
      objectType
    } = this.props;
    const {
      results
    } = this.state;
    const data = [...results];
    const parentId = event.data.data.id;
    const objectId = event.data.object.id;
    if (event.data.data.data[objectType]) {
      await dispatch(actions.itemActions(parentId).createObj().obj(objectType).delete());
    }
    try {
      await dispatch(actions.itemActions(parentId).createObj().obj(objectType).create({
        id: objectId,
        force: true
      }));
      data[event.data.index] = {
        ...event.data,
        success: true
      };
    } catch (ex) {
      data[event.data.index] = {
        ...event.data,
        ...ex
      };
    }
    this.setState({
      results: data
    });
  };
  validateObject = async id => {
    const {
      objectIdValidator,
      objectLookup,
      actions,
      objectNetwork,
      networkIdentifier,
      dispatch
    } = this.props;
    if (objectIdValidator(id) === false) {
      return null;
    }
    let result;
    if (typeof objectLookup === 'function') {
      result = await objectLookup(id);
    } else {
      result = await dispatch(actions.getDeviceByNetworkAlias(objectNetwork, id, networkIdentifier));
    }
    return result;
  };
  validateParentIds = parentIds => {
    const {
      parentIdValidator,
      parentColumnName
    } = this.props;
    return parentIds?.map(d => d[parentColumnName]).filter(parentIdValidator);
  };
  renderPair = () => {
    const {
      onClose,
      settingsPath,
      actions,
      objectType,
      parentObjectType,
      objectColumnName,
      parentColumnName,
      parentObjectName,
      objectName
    } = this.props;
    const {
      tabId,
      csv,
      loading,
      results,
      csvFileName
    } = this.state;
    switch (tabId) {
      case 'uploadResults':
        return /*#__PURE__*/React.createElement(BulkResultsTable, {
          settingsPath: settingsPath,
          data: results,
          onClose: this.onFinish,
          parentObjectName: parentObjectName,
          parentObjectType: parentObjectType,
          objectName: objectName,
          fileName: csvFileName,
          actions: actions,
          objectType: objectType,
          overridePairing: this.overridePairing,
          objectColumnName: objectColumnName,
          parentColumnName: parentColumnName
        });
      default:
        return /*#__PURE__*/React.createElement(FileForm, {
          fileName: csvFileName,
          onCancel: onClose,
          parentKey: parentColumnName,
          objectKey: objectColumnName,
          data: csv,
          updateState: this.updateState,
          loading: loading,
          onSubmit: this.onPair
        });
    }
  };
  render() {
    const {
      onClose,
      show
    } = this.props;
    const {
      tabId
    } = this.state;
    return /*#__PURE__*/React.createElement(Dialog, {
      variant: tabId === 'uploadResults' ? 'dialogFullPage' : 'dialog',
      showBackground: true,
      escapeWillClose: false,
      clickWillClose: false,
      show: !!show,
      targetId: "fullScreen",
      animation: "slideFromBottom",
      position: "center",
      onClose: onClose
    }, /*#__PURE__*/React.createElement(Toast, {
      id: "api-ui-pairing"
    }), /*#__PURE__*/React.createElement(Content, {
      relative: true
    }, /*#__PURE__*/React.createElement(Content.Header, {
      variant: "dialogTitle",
      style: {
        paddingBottom: '8px'
      }
    }, /*#__PURE__*/React.createElement(Flex, {
      direction: "row",
      justify: "space-between",
      align: "center"
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "rowS"
    }, /*#__PURE__*/React.createElement("img", {
      style: {
        height: 24,
        width: 24
      },
      src: pairIcon,
      alt: t('altPairIcon')
    }), /*#__PURE__*/React.createElement(Text, {
      variant: "dialogTitle"
    }, t('title'))), /*#__PURE__*/React.createElement(Button, {
      variant: "tertiaryIconic",
      onClick: onClose,
      icon: "fa fa-close"
    }))), /*#__PURE__*/React.createElement(Content.Area, null, /*#__PURE__*/React.createElement(Content, {
      relative: true,
      className: classnames(S.content)
    }, /*#__PURE__*/React.createElement(Content.Area, null, this.renderPair())))));
  }
}
export default connect((state, props) => {
  return {
    parentColumnName: t('idColumn', {
      name: props.parentObjectName,
      identifier: camelCaseToTitleCase(props.parentNetworkIdentifier) || 'ID'
    }),
    objectColumnName: t('idColumn', {
      name: props.objectName,
      identifier: camelCaseToTitleCase(props.networkIdentifier) || 'ID'
    })
  };
})(BulkPairFlow);